import { latestBrandReleases } from '../../../shared/brand-latest/latestReleases';

export interface NewBook2026 {
  isbn: string;
  code: string;
  title: string;
  subtitle: string;
  author: string;
  coverImage: string;
  publishDate?: string;
}

export const newBooks2026: NewBook2026[] = [
  ...latestBrandReleases
    .filter((book) => book.brandSlug === 'songye-culture')
    .map((book) => ({
      isbn: book.isbn,
      code: book.isbn,
      title: book.title,
      subtitle: book.subtitle,
      author: book.author,
      coverImage: book.coverImage,
      publishDate: book.publishDate,
    })),
  {
    isbn: "9786264169868",
    code: "HU073",
    title: "韓濟生的無創針灸新技術",
    subtitle: "經皮穴位電刺激療法",
    author: "韓濟生",
    coverImage: "https://storage.readdy-site.link/project_files/dddc8ccb-ecc6-4c35-a3ab-871b88c586cd/15317a3d-e071-46cb-b62b-e208049f3376_compressed_9786264169868_3D_72dpi.webp",
  },
  {
    isbn: "9786264169899",
    code: "HU070",
    title: "易經哲學",
    subtitle: "對生活智慧的啟發與應用",
    author: "高義展",
    coverImage: "https://storage.readdy-site.link/project_files/dddc8ccb-ecc6-4c35-a3ab-871b88c586cd/1fc9632e-ce84-4346-971d-bec217fbc985_compressed_9786264169899_3D_72dpi.webp",
  },
  {
    isbn: "9786264169776",
    code: "JU072",
    title: "走路痛得要死！從病因看懂膝蓋痛",
    subtitle: "",
    author: "高金亮",
    coverImage: "https://storage.readdy-site.link/project_files/dddc8ccb-ecc6-4c35-a3ab-871b88c586cd/fb31db77-2b81-4ae3-8cd3-10b36b1238ea_compressed_9786264169776.webp",
  },
  {
    isbn: "9786264169783",
    code: "TC071",
    title: "書影千年",
    subtitle: "從《山海經》到《紅樓夢》",
    author: "白羽",
    coverImage: "https://storage.readdy-site.link/project_files/dddc8ccb-ecc6-4c35-a3ab-871b88c586cd/8e4adac0-6c2b-4eb9-9845-ce253bdcaee1_compressed_9786264169783.webp",
  },
];
